/* eslint-disable prefer-template */
/* eslint-disable react/no-array-index-key */
/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-return-await */
import { memo, useEffect, useRef, useState, useMemo } from 'react';
import {
  FeatureGroup,
  MapContainer,
  GeoJSON,
  Marker,
  Popup,
} from 'react-leaflet';
import { Form } from '@unform/web';
import { EditControl } from 'react-leaflet-draw';
import Pagination from 'react-paginate';
import L from 'leaflet';
import {
  Card,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
  Button,
  Row,
  Col,
  CardBody,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
} from 'reactstrap';
import ReactLeafletGoogleLayer from 'react-leaflet-google-layer';
import { useParams, useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import shp from 'shpjs';
import {
  FaBars,
  FaArrowLeft,
  FaUpload,
  FaChevronLeft,
  FaChevronRight,
  FaMapMarker,
  FaLink,
  FaAngleDown,
  FaAngleUp,
  FaTrash,
  FaEllipsisH,
  FaEdit,
  FaCloudRain,
  FaRegTrashAlt,
} from 'react-icons/fa';
import {
  BsFillPinMapFill,
  BsFillDropletFill,
  BsSpeedometer,
  BsSunrise,
  BsThermometerSun,
} from 'react-icons/bs';
import { SiWindicss } from 'react-icons/si';
import geoViewport from '@mapbox/geo-viewport';
import {
  MdNorthEast,
  MdNorthWest,
  MdNorth,
  MdSouthEast,
  MdSouthWest,
  MdSouth,
  MdWest,
  MdEast,
  MdWaterDrop,
} from 'react-icons/md';
import {
  TbTemperature,
  TbTemperaturePlus,
  TbTemperatureMinus,
} from 'react-icons/tb';
import { WiHumidity, WiWindy, WiStrongWind } from 'react-icons/wi';
import { Input, ReactSelectAsync, Select } from '../../components/unform/index';

import 'leaflet-draw/dist/leaflet.draw.css';
import 'leaflet/dist/leaflet.css';

import TalhaoImg from '../../assets/images/talhao.png';
import EditImg from '../../assets/images/edit.png';
import DeleteImg from '../../assets/images/delete.png';
import MarkerImg from '../../assets/images/marker.png';

import LogoDf from '../../assets/images/logo.png';
import api from '../../services/api';
import FloatButtons from './floatButtons';

import SentinelHub from '../SentinelHub';
import ModalLog from './modalLog';
import { Translator } from '../../components/i18n';

import { useAuth } from '../../contexts/auth';

const swalWithBootstrapButtons = Swal.mixin({
  customClass: {
    confirmButton: 'ml-3 btn btn-success',
    cancelButton: 'btn btn-danger',
  },
  buttonsStyling: false,
});

const MyCustomMarker = L.Icon.extend({
  options: {
    shadowUrl: null,
    iconAnchor: new L.Point(12, 12),
    iconSize: new L.Point(20, 20),
    iconUrl: MarkerImg,
  },
});

function createMarker(feature, latlng) {
  return new L.CircleMarker(latlng, {
    radius: 5,
    fillOpacity: 0.1,
  });
}

function getDirection(dire) {
  if (dire === 'N') {
    return (
      <h1>
        <MdNorth style={{ marginRight: 15 }} />
        <Translator path="norte" />
      </h1>
    );
  }
  if (dire === 'NE') {
    return (
      <h1>
        <MdNorthEast style={{ marginRight: 15 }} />
        <Translator path="nordeste" />
      </h1>
    );
  }
  if (dire === 'NO') {
    return (
      <h1>
        <MdNorthWest style={{ marginRight: 15 }} />
        <Translator path="noroeste" />
      </h1>
    );
  }
  if (dire === 'O') {
    return (
      <h1>
        <MdWest style={{ marginRight: 15 }} />
        <Translator path="oeste" />
      </h1>
    );
  }
  if (dire === 'L') {
    return (
      <h1>
        <MdEast style={{ marginRight: 15 }} />
        <Translator path="leste" />
      </h1>
    );
  }
  if (dire === 'S') {
    return (
      <h1>
        <MdSouth style={{ marginRight: 15 }} />
        <Translator path="sul" />
      </h1>
    );
  }
  if (dire === 'SO') {
    return (
      <h1>
        <MdSouthWest style={{ marginRight: 15 }} />
        <Translator path="sudoeste" />
      </h1>
    );
  }
  if (dire === 'SE') {
    return (
      <h1>
        <MdSouthEast style={{ marginRight: 15 }} />
        <Translator path="sudeste" />
      </h1>
    );
  }
}

function deltaT(delta) {
  if (delta >= 2 && delta <= 8) {
    return (
      <>
        {delta} - <Translator path="ideal" />
      </>
    );
  }
  if (delta < 2) {
    return (
      <>
        {delta} - <Translator path="baixo" />
      </>
    );
  }
  if (delta > 8) {
    return (
      <>
        {delta} - <Translator path="arriscado" />
      </>
    );
  }
}

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function Map() {
  const { user } = useAuth();

  const obrigatorio = Translator({
    path: 'obrigatorio',
  });
  const erroBuscaDados = Translator({
    path: 'erroBuscaDados',
  });
  const dadosSalvosSucesso = Translator({
    path: 'dadosSalvosSucesso',
  });
  const erroSalvarDados = Translator({
    path: 'erroSalvarDados',
  });
  const erro = Translator({
    path: 'erro',
  });
  const atencao = Translator({
    path: 'atencao',
  });
  const necessarioSelecionarTalhao = Translator({
    path: 'necessarioSelecionarTalhao',
  });
  const naoCadastrado = Translator({
    path: 'naoCadastrado',
  });
  const apenasUmTalhao = Translator({
    path: 'apenasUmTalhao',
  });
  const apenasUmTalhaoSentinel = Translator({
    path: 'apenasUmTalhaoSentinel',
  });
  const naoCruzarLinha = Translator({
    path: 'naoCruzarLinha',
  });

  const temcertezaExcluirAssist = Translator({
    path: 'temcertezaExcluirAssist',
  });

  const operacaoNaorevertida = Translator({
    path: 'operacaoNaorevertida',
  });
  const sim = Translator({
    path: 'sim',
  });
  const nao = Translator({
    path: 'nao',
  });
  const sucesso = Translator({
    path: 'sucesso',
  });
  const semRegistros = Translator({
    path: 'excecoes.semregistros',
  });

  const formDocsRef = useRef(null);
  const featureRef = useRef(null);
  const talhaoRef = useRef(null);
  const insumoRef = useRef(null);
  const atividadeRef = useRef(null);
  const geoJSONref = useRef(null);

  const history = useHistory();
  const { id, idSafra } = useParams();
  // const [filtro, setFiltro] = useState({});

  const [modal, setModal] = useState(false);
  const [modalObs, setModalObs] = useState(false);
  const [modalInfo, setModalInfo] = useState(false);
  const [modalFiltro, setModalFiltro] = useState(false);
  const [modalCTalhao, setModalCTalhao] = useState(false);
  const [modalCadTalhao, setModalCadTalhao] = useState(false);
  const [modalVinculoSafraCroqui, setModalVinculoSafraCroqui] = useState(false);
  const [docs, setDocs] = useState(null);

  const [modalAti, setModalAti] = useState(false);
  const [atividades, setAtividades] = useState([]);
  const [modalInsumo, setModalInsumo] = useState(false);
  const [modalAtiCad, setModalAtiCad] = useState(false);

  const [modalSentinel, setModalSentinel] = useState(false);

  const toggleModalSentinel = () => setModalSentinel(!modalSentinel);

  const toggleModalAti = () => setModalAti(!modalAti);
  const toggleModalAtiCad = () => setModalAtiCad(!modalAtiCad);
  const toggleModalInsumo = () => setModalInsumo(!modalInsumo);

  const toggleModal = () => setModal(!modal);
  const toggleModalObs = () => setModalObs(!modalObs);
  const toggleModalInfo = () => setModalInfo(!modalInfo);
  const toggleModalFiltro = () => setModalFiltro(!modalFiltro);
  const toggleModalCTalhao = () => setModalCTalhao(!modalCTalhao);
  const toggleCadTalhaoSafraCultura = () => setModalCadTalhao(!modalCadTalhao);
  const toggleModalVinculoSafraCroqui = () =>
    setModalVinculoSafraCroqui(!modalVinculoSafraCroqui);

  const [insumos, setInsumos] = useState([]);
  const [dadosModalLog, setDadosModalLog] = useState(false);
  const [insumosCad, setInsumosCad] = useState([]);
  const [tipoInsumo, setTipoInsumo] = useState(null);

  const [defaultGeoJSON, setDefaultGeoJSON] = useState([]);
  const [geoJSONtoSave, setGeoJSONtoSave] = useState([]);
  const [talhoesVinculo, setTalhoesVinculo] = useState([]);

  const [selected, setSelected] = useState([]);
  const [map, setMap] = useState();

  const coordenadas = [-16.804541, -56.425781];

  // const [coordenadas, setCoordenadas] = useState([-16.804541, -56.425781]);
  const [zoomCoordenadas, setZoomCoordenadas] = useState(null);

  const [dataTalhoes, setDataTalhoes] = useState(null);
  const [nomeFazenda, setNomeFazenda] = useState(null);

  const [dataObs, setDataObs] = useState([]);

  const [layerCreated, setLayerCreated] = useState(null);

  const [filtrosTalhoes, setFiltrosTalhoes] = useState([]);
  const [tipoFiltro, setTipoFiltro] = useState(0);
  const [pragas, setPragas] = useState({
    show: false,
    obs: [],
  });

  const [coordenadasArray, setCoordenadasArray] = useState([]);

  const [randomKey, setRandomKey] = useState(1);

  const [marker, setMarker] = useState(null);

  const [clima, setClima] = useState(null);

  const [atividadeEdit, setAtividadeEdit] = useState(null);

  const [tipoAssist, setTipoAssist] = useState('');

  const [dispositivosPlugField, setDispositivosPlugField] = useState({
    show: false,
    dispositivos: [],
  });
  const [infosPlugField, setInfosPlugField] = useState({
    show: false,
    infos: [],
    tipo: 'P',
  });
  // const [tipoAssist, setTipoAssist] = useState('');

  async function plugField() {
    Swal.fire({
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    try {
      const { data } = await api.get('/plugfield');

      setDispositivosPlugField({
        show: true,
        dispositivos: data?.dispositivos,
      });
      Swal.close();
    } catch (err) {
      toast.error(erroBuscaDados);
      Swal.close();
    }
  }

  async function verInfosPuglfield(idDevice, tipo) {
    Swal.fire({
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    const body = {
      tipo,
      id: idDevice,
    };

    try {
      const { data } = await api.post('/plugfield-dados', body);

      setInfosPlugField({
        show: true,
        infos: data,
        tipo,
      });
    } catch (err) {
      toast.error(erroBuscaDados);
    }
    Swal.close();
  }

  async function filtrarConsultaAsyncCreate(inputValue) {
    const { data } = await api.get(`/cultura?descricao=${inputValue}`);

    return data.map((e) => ({ value: e.id, label: e.descricao }));
  }

  let selectOptions;
  const optionsCulturas = async (inputValue) =>
    await new Promise((resolve) => {
      clearTimeout(selectOptions);

      selectOptions = setTimeout(() => {
        resolve(filtrarConsultaAsyncCreate(inputValue));
      }, 500);
    });

  async function getFazendaData() {
    Swal.fire({
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      if (map) {
        const { data } = await api.get(
          `/fazenda-data/${id}/${idSafra}?bounds=true`
        );
        if (data && data?.coordenadas) {
          try {
            const { data: climaData } = await api.get(
              `/clima?latlong=${data?.coordenadas?.lati},${data?.coordenadas?.long}`
            );

            if (climaData) {
              setClima(climaData);
            }
          } catch {
            toast.error(erroBuscaDados);
          }

          const objZoomViewport = geoViewport.viewport(data?.bounds, [
            window.innerWidth,
            window.innerHeight,
          ]);

          setZoomCoordenadas({
            lati: data?.coordenadas?.lati,
            long: data?.coordenadas?.long,
            zoom: objZoomViewport?.zoom,
          });
          setNomeFazenda(data?.fazenda?.nome);
          setDefaultGeoJSON(data?.mapaFazenda?.objeto?.objeto);

          map.flyTo(
            [data?.coordenadas?.lati, data?.coordenadas?.long],
            objZoomViewport?.zoom,
            {
              animate: true,
              duration: 2,
            }
          );

          setTimeout(() => {
            Swal.close();
          }, 2000);
        } else {
          setNomeFazenda(data?.nome);
          setTimeout(() => {
            toggleModalCTalhao();
            Swal.close();
          }, 2000);
        }
      }
    } catch (err) {
      toast.error(erroBuscaDados);
      Swal.close();
    }
  }

  useEffect(() => {
    getFazendaData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map]);

  function reCenter() {
    map.flyTo(
      [zoomCoordenadas?.lati, zoomCoordenadas?.long],
      zoomCoordenadas?.zoom,
      {
        animate: true,
        duration: 1,
      }
    );
  }

  async function getInfosTalhoes() {
    if (selected.length) {
      try {
        const body = { ids_talhoes: selected, id_safra: idSafra };

        const { data } = await api.post('/talhoes', body);
        setDataTalhoes(data);
        toggleModalInfo();
      } catch (err) {
        toast.error(erroBuscaDados);
      }
    } else {
      Swal.fire(atencao, necessarioSelecionarTalhao, 'warning');
    }
  }

  async function getLogsTalhoes() {
    if (selected.length) {
      try {
        Swal.fire({
          allowOutsideClick: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        const body = { ids_talhoes: selected, id_safra: idSafra };

        const { data } = await api.post('/talhoes-filtros/log', body);
        setDadosModalLog(data);
      } catch (err) {
        const error = err?.response?.data?.error;
        toast.error(typeof error === 'string' ? error : erroBuscaDados);
      }
      Swal.close();
    } else {
      Swal.fire(atencao, necessarioSelecionarTalhao, 'warning');
    }
  }

  async function carregaFiltroTipo(origem, label) {
    if (selected.length) {
      try {
        Swal.fire({
          allowOutsideClick: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        const body = {
          ids_talhoes: selected,
          origem,
          id_safra: idSafra,
          id_fazenda: id,
        };
        const { data } = await api.post('/talhoes-filtros', body);
        if (data?.length) {
          setTipoFiltro({
            value: origem,
            label,
          });
          setFiltrosTalhoes(data);
        } else {
          toast.error(naoCadastrado);
        }
      } catch (err) {
        toast.error(erroBuscaDados);
      } finally {
        setTimeout(() => {
          Swal.close();
        }, 300);
      }
    } else {
      Swal.fire(atencao, necessarioSelecionarTalhao, 'warning');
    }
  }

  function limpaFiltros() {
    setTipoFiltro('');
    setFiltrosTalhoes([]);
    // esse para não bugar pra editar
    // setSelected([]);
    // featureRef.current.removeLayers();
  }

  async function carregaModalFiltros() {
    if (selected.length) {
      try {
        if (tipoFiltro?.value === 'PC') {
          limpaFiltros();
        }
        toggleModalFiltro();
      } catch (err) {
        toast.error(erroBuscaDados);
      }
    } else {
      Swal.fire(atencao, necessarioSelecionarTalhao, 'warning');
    }
  }

  async function handleSubmitCadtalhao(data) {
    const errors = {};

    Object.keys(data).forEach((f) => {
      if (!data[f]) {
        errors[f] = obrigatorio;
      }
    });

    talhaoRef.current.setErrors(errors);

    if (!Object.keys(errors).length) {
      setDefaultGeoJSON([]);
      Swal.fire({
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        const body = {
          descricao: data.descricao,
          id_fazenda: id,
          geoJSON: [
            {
              fileName: 'MapCreated',
              type: 'FeatureCollection',
              features: [
                {
                  type: 'Feature',
                  properties: {},
                  geometry: {
                    type: 'Polygon',
                    coordinates: [coordenadasArray],
                  },
                },
              ],
            },
          ],
        };

        const { data: talhao } = await api.post('/talhao', body);
        const idTalhao = talhao?.talhao?.id;

        const body2 = {
          id_cultura_talhao: [
            { id_talhao: idTalhao, id_cultura: data.id_cultura },
          ],
          id_fazenda: id,
          id_safra: idSafra,
        };

        const { data: retorno } = await api.post('/safra-talhao', body2);

        featureRef.current.removeLayer(layerCreated);
        setDefaultGeoJSON(retorno?.retorno);
        toggleCadTalhaoSafraCultura();
        getFazendaData();
        Swal.close();
      } catch (err) {
        toast.error(erroSalvarDados);
        Swal.close();
      }
    }
  }

  async function saveCroquiFazenda(geoJSON) {
    Swal.fire({
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const talhoes = [];

    geoJSON.forEach((element) => {
      element.features.forEach((features) => {
        talhoes.push(features.properties.Nome);
      });
    });

    try {
      setGeoJSONtoSave(geoJSON);
      setTalhoesVinculo(talhoes);

      toggleModalCTalhao();
      toggleModalVinculoSafraCroqui();

      setTimeout(() => {
        Swal.close();
      }, 1000);
    } catch (err) {
      toast.error(err?.response?.data?.error || erroSalvarDados);
      Swal.close();
    }
  }

  async function handlePragas() {
    if (pragas.show) {
      return setPragas((old) => ({
        ...old,
        show: false,
      }));
    }
    if (pragas.obs.length) {
      return setPragas((old) => ({
        ...old,
        show: true,
      }));
    }
    Swal.fire({
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const { data } = await api.get(`/observacoes/${idSafra}/pragas`);
      if (!data.length) {
        Swal.fire(atencao, semRegistros, 'warning');
      } else {
        setPragas({
          show: true,
          obs: data,
        });
        Swal.close();
      }
    } catch (err) {
      toast.error(err?.response?.data?.error || erroSalvarDados);
      Swal.close();
    }
  }

  async function saveCroquiTalhao(body) {
    const errors = {};

    Object.keys(body).forEach((f) => {
      if (!body[f]) {
        errors[f] = obrigatorio;
      }
    });

    talhaoRef.current.setErrors(errors);

    if (!Object.keys(errors).length) {
      Swal.fire({
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      geoJSONtoSave.forEach((element) => {
        element.features.forEach((features) => {
          // eslint-disable-next-line prefer-destructuring
          features.properties.id_cultura = Object.keys(body)
            .filter((key) => key === features.properties.Nome)
            .map((e) => body[e])[0];
        });
      });

      const obj = {
        id_fazenda: id,
        id_produtor: null,
        id_talhao: null,
        id_safra: idSafra,
        origem_: 'CRM',
        geoJSON: geoJSONtoSave,
      };

      try {
        const { data } = await api.post('/arquivo', obj);
        map.flyTo([data?.coordenadas?.lati, data?.coordenadas?.long], 13, {
          animate: true,
          duration: 3,
        });
        toast.success(dadosSalvosSucesso);
        setTalhoesVinculo([]);
        toggleModalVinculoSafraCroqui();
        setTimeout(() => {
          setDefaultGeoJSON(data?.obj);
          Swal.close();
        }, 3000);
      } catch (err) {
        toast.error(err?.response?.data?.error || erroSalvarDados);
        Swal.close();
      }
    }
  }

  function onCreated(e) {
    const { layer } = e;

    const arrayOfCoordinates = [];
    setLayerCreated(layer);
    if (layer.getLatLngs()[0].length) {
      for (let index = 0; index < layer.getLatLngs()[0].length; index += 1) {
        const element = layer.getLatLngs()[0][index];
        const { lat, lng } = element;

        arrayOfCoordinates.push([lng, lat]);

        if (index + 1 === layer.getLatLngs()[0].length) {
          arrayOfCoordinates.push(arrayOfCoordinates[0]);
        }
      }
      setCoordenadasArray(arrayOfCoordinates);
      toggleCadTalhaoSafraCultura();
    }
  }

  async function onEdited(e) {
    const talhoesToEdit = [];

    e.layers.eachLayer((a) => {
      const { feature } = a;

      const arrayOfCoordinates = [];
      for (let index = 0; index < a.getLatLngs()[0].length; index += 1) {
        const element = a.getLatLngs()[0][index];
        const { lat, lng } = element;

        arrayOfCoordinates.push([lng, lat]);

        if (index + 1 === a.getLatLngs()[0].length) {
          arrayOfCoordinates.push(arrayOfCoordinates[0]);
        }
      }

      talhoesToEdit.push({
        id_talhao: feature?.properties?.id_talhao,
        coordenadas: arrayOfCoordinates,
      });
    });

    try {
      const body = { id_fazenda: id, id_safra: idSafra, obj: talhoesToEdit };

      const { data } = await api.put('/talhao-obj', body);

      setDefaultGeoJSON(data?.retorno);
      Swal.close();
    } catch (err) {
      toast.error(erroSalvarDados);
    }
  }

  function onDeleted(e) {
    console.log('onDeleted', e);
  }

  function onDrawStart(e) {
    console.log('onDrawStart', e);
  }

  const eachGeoJSONOBJ = (areaItem, layer) => {
    let areaName;
    if (areaItem?.properties?.Nome) {
      areaName = `Nome: ${areaItem?.properties?.Nome}`;
    } else if (areaItem?.properties?.ID_Amostra) {
      areaName = `ID Amostra: ${areaItem?.properties?.ID_Amostra}`;
    } else if (areaItem?.properties?.ID) {
      areaName = `ID: ${areaItem?.properties?.ID}`;
    } else if (areaItem?.properties?.id) {
      areaName = `ID: ${areaItem?.properties?.id}`;
    } else if (areaItem?.properties?.nome) {
      areaName = `Nome: ${areaItem?.properties?.nome}`;
    }

    layer.bindPopup(`${areaName}`);
    layer.on({
      click: () => {
        const obj = layer.feature.properties.id_talhao;
        if (talhoesVinculo.length) {
          return;
        }
        setSelected((old) => {
          const contain = old.some((sel) => sel === obj);

          if (!contain) {
            featureRef.current.addLayer(layer);
            return [...old, obj];
          }

          featureRef.current.removeLayer(layer);
          setRandomKey(Math.random());

          return old.filter((selec) => selec !== obj);
        });
      },
    });
  };

  function selectAll() {
    const layers = {};

    Object.keys(map._layers).forEach((e) => {
      if (map._layers[e]._order) {
        if (!selected.length) {
          layers[e] = map._layers[e];
          featureRef.current.addLayer(map._layers[e]);
        }
      }
    });

    if (!selected.length) {
      const idsTalhoes = [];
      Object.keys(layers).forEach((e) => {
        idsTalhoes.push(layers[e].feature.properties.id_talhao);
      });
      setSelected(idsTalhoes);
    } else {
      setSelected([]);
    }
  }

  const FilterGeo = memo(() => {
    function createMarkerFilter(feature, latlng) {
      return new L.CircleMarker(latlng, {
        radius: 5,
        fillOpacity: 0.1,
      });
    }
    function onEachFeature(_, layer) {
      // eslint-disable-next-line no-unreachable
      const label =
        layer.feature.properties[tipoFiltro?.filtro] ||
        layer.feature.properties[tipoFiltro?.filtro?.toUpperCase()];

      if (layer.unbindToolTip) {
        layer.unbindToolTip();
      }

      if (
        tipoFiltro?.value === 'PC' ||
        layer.feature.geometry.type !== 'Point'
      ) {
        layer.bindTooltip(
          String(
            layer.feature.properties.ID_Amostra ||
              layer.feature.properties.id ||
              layer.feature.properties.ID ||
              ''
          ),
          {
            direction: 'center',
            sticky: true,
          }
        );
      }

      layer
        .bindTooltip(String(label || 0), {
          permanent: true,
          direction: 'center',
          sticky: false,
        })
        .openTooltip();
    }

    if (filtrosTalhoes?.length === 0 && !tipoFiltro?.filtro) {
      return null;
    }

    return filtrosTalhoes.map((talhao, i) => (
      <GeoJSON
        key={i + talhao.obj.objeto[0].fileName}
        data={talhao.obj.objeto[0].features}
        pointToLayer={createMarkerFilter}
        onEachFeature={(area, layer) => onEachFeature(area, layer)}
        style={(a) => {
          const cor =
            a?.properties['cor_' + tipoFiltro?.filtro] ||
            a?.properties['cor_' + tipoFiltro?.filtro?.toUpperCase()];
          const colors = {
            color: 'black',
            fillColor: cor || 'transparent',
          };

          if (tipoFiltro?.value === 'PC') {
            colors.color = '#FFFF00';
            colors.fillColor = '#FFFF001c';
          } else if (a?.geometry.type === 'Point') {
            colors.color = 'transparent';
            colors.fillColor = 'transparent';
          }
          return {
            ...colors,
            fill: true,
            stroke: '#ffff',
            weight: 2,
            fillOpacity: 0.8,
            strokeWidth: 2,
          };
        }}
      />
    ));
  }, [filtrosTalhoes, tipoFiltro?.filtro]);

  function toggleFiltroPC() {
    if (tipoFiltro?.value !== 'PC') {
      carregaFiltroTipo('PC', 'Ponto de Coleta');
    } else {
      limpaFiltros();
    }
  }

  async function getAtvidades({ changePage = false, page }) {
    if (selected?.length && selected?.length <= 1) {
      try {
        if (!changePage) {
          toggleModalAti();
        }
        const { data: safraTalhao } = await api.get(
          `/get-safra-talhao/${selected[0]}/${idSafra}`
        );
        const { data } = await api.get(
          `/atividade/${safraTalhao?.id}?page=${page || 1}`
        );
        setAtividades(data);
      } catch (err) {
        toast.error(erroBuscaDados);
      }
    } else {
      Swal.fire(atencao, necessarioSelecionarTalhao, 'warning');
    }
  }

  async function getObs({ changePage = false, page }) {
    try {
      if (!changePage) {
        toggleModalObs();
      }
      const { data } = await api.get(
        `/observacoes/${idSafra}?page=${page || 1}`
      );
      setDataObs(data);
    } catch (err) {
      toast.error(erroBuscaDados);
    }
  }

  async function getDocs({ page } = {}) {
    if (selected.length > 1) {
      return Swal.fire(atencao, apenasUmTalhao, 'warning');
    }
    try {
      Swal.fire({
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      if (selected.length === 1) {
        const { data } = await api.get(
          `/documentos/${idSafra}/safra/${selected[0]}`
        );
        setTipoAssist('Talhão');
        setDocs(data);
      } else {
        const { data } = await api.get(
          `/documentos/${idSafra}/safra?all=true&page=${page || 1}`
        );
        setTipoAssist('Safra');
        setDocs(data);
      }
      Swal.close();
    } catch (err) {
      toast.error(err.mensagem);
      Swal.close();
    }
  }

  function viewOnMap(lat, long, dados) {
    setMarker({
      position: [Number(lat), Number(long)],
      dados,
    });
    map.flyTo([lat, long], 20, {
      animate: true,
      duration: 1,
    });
    toggleModalObs();
  }

  async function handleSubmitDocs(e) {
    const errors = {};

    if (!e.nome_arquivo) {
      errors.nome_arquivo = obrigatorio;
    }
    if (!e.file) {
      errors.file = obrigatorio;
    }

    formDocsRef.current.setErrors(errors);
    if (Object.keys(errors).length) {
      return toast.error(erro);
    }

    const formData = new FormData();
    formData.append('nome_arquivo', e.nome_arquivo);
    formData.append('file', e.file);

    if (!selected.length) {
      formData.append('id_safra', idSafra);
    } else {
      formData.append('id_safra_talhao', docs.id_safra_talhao);
    }

    try {
      Swal.fire({
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      const { data } = await api.post('/documentos', formData);
      setDocs((old) => ({ ...old, obs: docs.obs.concat(data), novo: false }));
      Swal.close();
    } catch (err) {
      toast.error(err.mensagem);
      Swal.close();
    }
  }

  function returnDias(data) {
    const dias = Math.round((data - new Date()) / 8.64e7);
    if (dias === 0) {
      const horas = (data - new Date()) / 3.6e6;
      if (horas < 1) {
        return `${Math.round(horas / 3600)}m`;
      }
      return `${Math.round(horas)}h`;
    }
    return `${dias}d`;
  }

  const returnBadge = (inicio, fim, status = '') => {
    if (status === 'I') {
      return (
        <div
          style={{ borderRadius: 15, padding: 5, backgroundColor: '#D1F0D5' }}
        >
          <h5 style={{ color: '#3EC24F' }}>
            <Translator path="badgeConcluido" />
          </h5>
        </div>
      );
    }
    if (inicio > new Date()) {
      return (
        <div
          style={{ borderRadius: 15, padding: 5, backgroundColor: '#E7EFEB' }}
        >
          <h5>
            <Translator path="badgeInicia" /> {returnDias(inicio)}
          </h5>
        </div>
      );
    }
    if (fim < new Date()) {
      return (
        <div
          style={{ borderRadius: 15, padding: 5, backgroundColor: '#FFEAD6' }}
        >
          <h5 style={{ color: '#FF9F43' }}>
            <Translator path="badgeRevisar" />
          </h5>
        </div>
      );
    }
    return (
      <div style={{ borderRadius: 15, padding: 5, backgroundColor: '#D6EDFF' }}>
        <h5>
          <Translator path="badgeTermina" /> {returnDias(fim)}
        </h5>
      </div>
    );
  };

  function randstr() {
    return Math.random().toString(36).replace('0.', 'id');
  }

  function handleSubmitInsumo(data) {
    const errors = {};
    Object.keys(data).forEach((f) => {
      if (!data[f]) {
        errors[f] = obrigatorio;
      }
    });

    insumoRef.current.setErrors(errors);

    if (!Object.keys(errors).length) {
      data.id = randstr();

      const array = [...insumosCad];
      array.push(data);
      setInsumosCad(array);
      setTipoInsumo(null);
      toggleModalInsumo();
    }
  }

  async function handleSubmitAtividade(data, edit) {
    const errors = {};
    Object.keys(data).forEach((f) => {
      if (!data[f] && f !== 'observacoes') {
        errors[f] = obrigatorio;
      }
    });

    atividadeRef.current.setErrors(errors);

    if (!Object.keys(errors).length) {
      Swal.fire({
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const { data: safraTalhao } = await api.get(
        `/get-safra-talhao/${selected[0]}/${idSafra}`
      );
      if (edit === false) {
        data.id_safra_talhao = safraTalhao?.id;
        data.insumos = insumosCad;

        await api.post('/atividade', data);
      } else {
        data.addInsumos = insumosCad;
        await api.put(`/atividade-edit-web/${atividadeEdit?.id}`, data);

        setAtividadeEdit(null);
      }

      const { data: atividadesReturn } = await api.get(
        `/atividade/${safraTalhao?.id}?page=${1}`
      );
      setAtividades(atividadesReturn);
      setInsumosCad([]);
      toggleModalAtiCad();
      Swal.close();
    }
  }

  async function getEditAtividade(idAtividade) {
    try {
      const { data } = await api.get(`/atividade-id/${idAtividade}`);

      setAtividadeEdit(data);
      setInsumosCad(data?.AtividadeInsumos);
      toggleModalAtiCad();
    } catch (err) {
      toast.error(erroBuscaDados);
    }
  }

  async function getSentinelData() {
    if (selected?.length && selected?.length <= 1) {
      toggleModalSentinel();
    } else {
      Swal.fire(atencao, apenasUmTalhaoSentinel, 'warning');
    }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const googleMaps = useMemo(() => (
    <ReactLeafletGoogleLayer
      apiKey="AIzaSyBCdSTyT5w8MEFXVyqz19IV3AMD9D3fUGw"
      type="hybrid"
      // keepBuffer={20}
      // updateInterval={1}
      pane="mapPane"
    />
  ));

  const handleDelete = async (idAssist) => {
    swalWithBootstrapButtons
      .fire({
        title: temcertezaExcluirAssist,
        text: operacaoNaorevertida,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: sim,
        cancelButtonText: nao,
        reverseButtons: true,
      })
      .then(async (result) => {
        if (result.value) {
          Swal.fire({
            allowOutsideClick: false,
            showConfirmButton: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
          try {
            await api.delete(`/documentos/${idAssist}`);
            getDocs();
            toast.success(sucesso);
          } catch (er) {
            toast.error(erro);
          }
          Swal.close();
        }
      });
  };

  const aplicarFiltro = (filtro) => {
    Swal.fire({
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    setTimeout(() => {
      setTipoFiltro((old) => ({ ...old, filtro }));
      toggleModalFiltro();
      Swal.close();
    }, 300);
  };

  return (
    <>
      <div className="floating-menu">
        <input type="checkbox" />
        <span className="plus-icon">
          <FaBars />
        </span>
        <FloatButtons
          {...{
            getInfosTalhoes,
            getLogsTalhoes,
            carregaModalFiltros,
            toggleFiltroPC,
            limpaFiltros,
            getAtvidades,
            getObs,
            getDocs,
            getSentinelData,
            handlePragas,
            selectAll,
            plugField,
          }}
        />
      </div>
      <div
        className="floating-arrow"
        onClick={() => {
          history.push('/fazendas');
        }}
        aria-hidden="true"
      >
        <span className="plus-icon">
          <FaArrowLeft />
        </span>
      </div>
      <div className="fazenda-nome">
        <span className="plus-icon">{nomeFazenda}</span>
      </div>
      <div className="df-logo">
        <img className="logo-map" src={LogoDf} alt="logo" />
      </div>
      {clima && (
        <>
          <div className="div-clima-img">
            <img
              width={
                clima?.current?.condition?.code === 1243 ||
                clima?.current?.condition?.code === 1003 ||
                clima?.current?.condition?.code === 1063 ||
                clima?.current?.condition?.code === 1135 ||
                clima?.current?.condition?.code === 1006
                  ? 48
                  : 55
              }
              src={clima?.current?.condition?.icon}
              alt=""
            />
          </div>
          <div className="div-clima-temp">
            <h6>{clima?.current?.temp_c}º</h6>
          </div>
          <div className="div-clima-img-umid">
            <BsFillDropletFill size={24} color="#0481ff" />
          </div>
          <div className="div-clima-umid">
            <h6>{clima?.current?.humidity}%</h6>
          </div>
          <div className="div-clima-img-wind">
            <SiWindicss size={22} color="lightgray" />
          </div>
          <div className="div-clima-wind">
            <h6>{clima?.current?.wind_kph}Km/h</h6>
          </div>
        </>
      )}
      <div className="return-location">
        <Button onClick={() => reCenter()} className="btn">
          <BsFillPinMapFill />
        </Button>
      </div>
      {modalSentinel && (
        <SentinelHub
          modalSentinel={modalSentinel}
          toggleModalSentinel={toggleModalSentinel}
          selectedtalhao={selected}
        />
      )}
      <Card className="h-110 w-100 card-map">
        <MapContainer
          preferCanvas
          center={coordenadas}
          whenCreated={setMap}
          zoom={3}
          style={{
            height: '100%',
          }}
          id="map-id"
          zoomControl={false}
          attributionControl={false}
          editable
        >
          {googleMaps}
          {marker && (
            <Marker
              key="marker"
              position={marker?.position}
              icon={new MyCustomMarker()}
            >
              <br />
              <Popup>
                <Row>
                  {marker?.dados?.tipo_observacao} - {marker?.dados?.descricao}
                </Row>
                <br />
                <Row>
                  <Button
                    className="btn-sm"
                    color="danger"
                    onClick={() => setMarker(null)}
                  >
                    <Translator path="limpar" />
                  </Button>
                </Row>
              </Popup>
            </Marker>
          )}

          {pragas.show &&
            pragas.obs.map((m) => (
              <Marker
                key="marker"
                position={{
                  lat: Number(m.lat),
                  lng: Number(m.long),
                }}
                icon={new MyCustomMarker()}
              >
                <br />
                <Popup>
                  <Row>
                    <img src={m.img_path} alt={m?.descricao} width="100%" />
                  </Row>
                  <Row>
                    {m?.tipo_observacao} - {m?.descricao}
                  </Row>
                </Popup>
              </Marker>
            ))}

          <FilterGeo />

          {!filtrosTalhoes.length &&
            !tipoFiltro?.filtro &&
            defaultGeoJSON?.map((e) => (
              <>
                <GeoJSON
                  key={e?.fileName + randomKey}
                  ref={geoJSONref}
                  data={e?.features}
                  onEachFeature={eachGeoJSONOBJ}
                  pointToLayer={createMarker}
                  style={(a) => {
                    const obj = a?.properties?.id_talhao;
                    const isSelected = selected.some((sel) => sel === obj);
                    return {
                      fill: true,
                      stroke: true,
                      color: isSelected ? 'rgba(0,255,0,1)' : '#FFFF00',
                      fillColor: isSelected ? '#0d6efd61' : '#FFFF004D',
                      opacity: 0.8,
                      dashArray: '30 10',
                      weight: 2,
                      fillOpacity: 0.8,
                      strokeWidth: 2,
                    };
                  }}
                />
              </>
            ))}

          {filtrosTalhoes.length > 0 &&
            defaultGeoJSON?.map((e) => (
              <>
                <GeoJSON
                  key={e?.fileName + randomKey}
                  ref={geoJSONref}
                  data={e?.features}
                  pointToLayer={createMarker}
                  style={(a) => {
                    const obj = a?.properties?.id_talhao;
                    const isSelected = selected.some((sel) => sel === obj);
                    return {
                      fill: true,
                      stroke: true,
                      color: isSelected ? 'rgba(0,255,0,1)' : '#000',
                      fillColor: isSelected ? '#0d6efd61' : '#000000a1',
                      opacity: 0.8,
                      dashArray: '30 10',
                      weight: 2,
                      fillOpacity: 0.8,
                      strokeWidth: 2,
                    };
                  }}
                />
              </>
            ))}

          <FeatureGroup ref={featureRef}>
            <EditControl
              position="topright"
              onEdited={onEdited}
              onCreated={onCreated}
              onDeleted={onDeleted}
              onDrawStart={onDrawStart}
              edit={{
                remove: false,
              }}
              draw={{
                rectangle: false,
                circle: false,
                circlemarker: false,
                polyline: false,
                marker: false,
                polygon: {
                  allowIntersection: false,
                  drawError: {
                    color: '#fa0505',
                    message: naoCruzarLinha,
                  },
                  shapeOptions: {
                    color: '#43b02a',
                  },
                  icon: new MyCustomMarker(),
                },
              }}
            />
          </FeatureGroup>
        </MapContainer>
      </Card>

      <Modal isOpen={modalInfo} toggle={toggleModalInfo}>
        <ModalHeader toggle={toggleModalInfo}>
          <Translator path="mapa.info.label" />
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col lg={6} className="text-center">
              <p>
                <strong>
                  <Translator path="mapa.info.fazenda" />:{' '}
                </strong>
                {nomeFazenda}
              </p>
            </Col>
            <Col lg={6} className="text-center">
              <p>
                <strong>
                  <Translator path="mapa.info.tamanho" />:{' '}
                </strong>
                {Number(dataTalhoes?.totalAreaFazenda).toFixed(2)} h
              </p>
            </Col>
          </Row>
          <Table responsive>
            <thead>
              <tr>
                <th className="text-center">
                  <Translator path="mapa.info.nome" />
                </th>
                <th className="text-center">
                  <Translator path="mapa.info.tamanho" />
                </th>
                <th className="text-center">
                  <Translator path="mapa.info.cultura" />
                </th>
                <th className="text-center">
                  <Translator path="mapa.info.status" />
                </th>
              </tr>
            </thead>
            <tbody>
              {dataTalhoes?.safraTalhoes?.length > 0 ? (
                dataTalhoes?.safraTalhoes?.map((c) => (
                  <tr key={c?.id}>
                    <td className="text-center">{c?.Talhao?.descricao}</td>
                    <td className="text-center">
                      {Number(c?.Talhao?.tamanho).toFixed(2)} h
                    </td>
                    <td className="text-center">{c?.Cultura?.descricao}</td>
                    <td className="text-center">{c?.Talhao?.status}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td>
                    <Translator path="excecoes.semregistros" />
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={toggleModalInfo}>
            Ok
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modalFiltro} toggle={toggleModalFiltro} size="lg">
        <ModalHeader toggle={toggleModalFiltro}>
          <Translator path="mapa.filtros.label" />
        </ModalHeader>
        <Table responsive hidden={!filtrosTalhoes.length}>
          <thead>
            <tr>
              <th className="text-center">{tipoFiltro?.label}</th>
            </tr>
          </thead>
          <tbody hidden={tipoFiltro?.value !== 'MF'}>
            <tr key="1">
              <td className="text-center">
                <Button
                  outline
                  color="warning"
                  onClick={() => {
                    aplicarFiltro('arg');
                  }}
                  block
                >
                  <Translator path="Argila" />
                </Button>
              </td>
            </tr>
            <tr key="2">
              <td className="text-center">
                <Button
                  outline
                  color="warning"
                  onClick={() => {
                    aplicarFiltro('are');
                  }}
                  block
                >
                  <Translator path="Areia" />
                </Button>
              </td>
            </tr>
            <tr key="3">
              <td className="text-center">
                <Button
                  outline
                  color="warning"
                  onClick={() => {
                    aplicarFiltro('sil');
                  }}
                  block
                >
                  <Translator path="Limo" />
                </Button>
              </td>
            </tr>
            <tr key="4">
              <td className="text-center">
                <Button
                  outline
                  color="warning"
                  onClick={() => {
                    aplicarFiltro('mo');
                  }}
                  block
                >
                  <Translator path="MateriaOrganica" />
                </Button>
              </td>
            </tr>
            <tr key="5">
              <td className="text-center">
                <Button
                  outline
                  color="warning"
                  onClick={() => {
                    aplicarFiltro('ph');
                  }}
                  block
                >
                  <Translator path="ph" />
                </Button>
              </td>
            </tr>
            <tr key="6">
              <td className="text-center">
                <Button
                  outline
                  color="warning"
                  onClick={() => {
                    aplicarFiltro('s');
                  }}
                  block
                >
                  <Translator path="Enxofre" />
                </Button>
              </td>
            </tr>
            <tr key="7">
              <td className="text-center">
                <Button
                  outline
                  color="warning"
                  onClick={() => {
                    aplicarFiltro('ca');
                  }}
                  block
                >
                  <Translator path="Calcio" />
                </Button>
              </td>
            </tr>
            <tr key="7.1">
              <td className="text-center">
                <Button
                  outline
                  color="warning"
                  onClick={() => {
                    aplicarFiltro('cu');
                  }}
                  block
                >
                  <Translator path="Cobre" />
                </Button>
              </td>
            </tr>
            <tr key="8">
              <td className="text-center">
                <Button
                  outline
                  color="warning"
                  onClick={() => {
                    aplicarFiltro('p');
                  }}
                  block
                >
                  <Translator path="Fosforo" />
                </Button>
              </td>
            </tr>
            <tr key="8">
              <td className="text-center">
                <Button
                  outline
                  color="warning"
                  onClick={() => {
                    aplicarFiltro('mg');
                  }}
                  block
                >
                  <Translator path="Magnesio" />
                </Button>
              </td>
            </tr>
            <tr key="8.1">
              <td className="text-center">
                <Button
                  outline
                  color="warning"
                  onClick={() => {
                    aplicarFiltro('k');
                  }}
                  block
                >
                  <Translator path="Potassio" />
                </Button>
              </td>
            </tr>
            <tr key="9">
              <td className="text-center">
                <Button
                  outline
                  color="warning"
                  onClick={() => {
                    aplicarFiltro('v');
                  }}
                  block
                >
                  <Translator path="Saturacao" />
                </Button>
              </td>
            </tr>
            <tr key="10">
              <td className="text-center">
                <Button
                  outline
                  color="warning"
                  onClick={() => {
                    aplicarFiltro('ctc');
                  }}
                  block
                >
                  <Translator path="CTC" />
                </Button>
              </td>
            </tr>
            <tr key="11">
              <td className="text-center">
                <Button
                  outline
                  color="warning"
                  onClick={() => {
                    aplicarFiltro('b');
                  }}
                  block
                >
                  <Translator path="Boro" />
                </Button>
              </td>
            </tr>
            <tr key="12">
              <td className="text-center">
                <Button
                  outline
                  color="warning"
                  onClick={() => {
                    aplicarFiltro('mn');
                  }}
                  block
                >
                  <Translator path="Manganes" />
                </Button>
              </td>
            </tr>
            <tr key="13">
              <td className="text-center">
                <Button
                  outline
                  color="warning"
                  onClick={() => {
                    aplicarFiltro('z');
                  }}
                  block
                >
                  <Translator path="Zinco" />
                </Button>
              </td>
            </tr>
          </tbody>
          <tbody hidden={tipoFiltro?.value !== 'MA'}>
            <tr key="1">
              <td className="text-center">
                <Button
                  outline
                  color="info"
                  onClick={() => {
                    aplicarFiltro('cal');
                  }}
                  block
                >
                  <Translator path="Calcitico" />
                </Button>
              </td>
            </tr>
            <tr key="2">
              <td className="text-center">
                <Button
                  outline
                  color="info"
                  onClick={() => {
                    aplicarFiltro('dol');
                  }}
                  block
                >
                  <Translator path="Dolomitico" />
                </Button>
              </td>
            </tr>
            <tr key="3">
              <td className="text-center">
                <Button
                  outline
                  color="info"
                  onClick={() => {
                    aplicarFiltro('fos');
                  }}
                  block
                >
                  <Translator path="Fosfatagem" />
                </Button>
              </td>
            </tr>
            <tr key="4">
              <td className="text-center">
                <Button
                  outline
                  color="info"
                  onClick={() => {
                    aplicarFiltro('pot');
                  }}
                  block
                >
                  <Translator path="Potassagem" />
                </Button>
              </td>
            </tr>
            <tr key="5">
              <td className="text-center">
                <Button
                  outline
                  color="info"
                  onClick={() => {
                    aplicarFiltro('sul');
                  }}
                  block
                >
                  <Translator path="Sulfatagem" />
                </Button>
              </td>
            </tr>
          </tbody>
        </Table>
        <Row hidden={!filtrosTalhoes.length}>
          <Col>
            <Button
              color="primary"
              onClick={() => {
                limpaFiltros();
              }}
              block
            >
              <Translator path="mapa.filtros.limparfiltros" />
            </Button>
          </Col>
        </Row>

        <Table responsive hidden={filtrosTalhoes.length}>
          <thead>
            <tr>
              <th className="text-center">
                <Translator path="mapa.filtros.tipofiltro" />
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="text-center">
                <Button
                  outline
                  color="info"
                  onClick={() => carregaFiltroTipo('MA', 'Mapa de aplicação')}
                  block
                >
                  <Translator path="mapa.filtros.mapaaplicacao" />
                </Button>
              </td>
            </tr>
            <tr>
              <td className="text-center">
                <Button
                  outline
                  color="warning"
                  onClick={() => carregaFiltroTipo('MF', 'Mapa de fertilidade')}
                  block
                >
                  <Translator path="mapa.filtros.mapafertilidade" />
                </Button>
              </td>
            </tr>
          </tbody>
        </Table>
      </Modal>

      <Modal isOpen={modalCTalhao} toggle={toggleModalCTalhao} size="md">
        <ModalHeader toggle={toggleModalCTalhao}>
          <Translator path="mapa.semtalhoesCad" />
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col lg={6} className="card-infos-talhao">
              <h4>
                <Translator path="mapa.crieTalhao" />
              </h4>
              <hr className="hr" />
              <h5>
                <Translator path="mapa.utilizeFerramenta" />
              </h5>
              <hr className="hr" />
              <Row>
                <Col lg={4}>
                  <img
                    src={TalhaoImg}
                    className="imgcontroles"
                    alt="Criar talhão"
                  />
                  <p>
                    <Translator path="mapa.criar" />
                  </p>
                </Col>
                <Col lg={4}>
                  <img
                    src={EditImg}
                    className="imgcontroles"
                    alt="Editar talhão"
                  />
                  <p>
                    <Translator path="mapa.editar" />
                  </p>
                </Col>
                {/* <Col lg={4}>
                  <img
                    src={DeleteImg}
                    className="imgcontroles"
                    alt="Deletar talhão"
                  />
                  <p>Deletar</p>
                </Col> */}
              </Row>
            </Col>
            <Col lg={6} className="card-infos-talhao">
              <h4>
                <Translator path="mapa.fazerUpload" />
              </h4>
              <hr className="hr" />
              <h5>
                <Translator path="mapa.fazerUploadZip" />
              </h5>
              <hr className="hr" />
              <Row>
                <Col lg={12}>
                  <div className="file">
                    <label htmlFor="upload-archive">
                      <FaUpload />
                      &nbsp;&nbsp;
                      <Translator path="mapa.selecione" />
                    </label>
                    <input
                      id="upload-archive"
                      type="file"
                      required
                      onChange={(event) => {
                        event.preventDefault();
                        const file = event.target.files[0];
                        if (!file) {
                          return;
                        }
                        const reader = new window.FileReader();
                        reader.readAsArrayBuffer(file);

                        reader.onloadend = () => {
                          const buffer = reader.result;

                          shp(buffer).then((geojson) => {
                            if (geojson.length) {
                              saveCroquiFazenda(geojson);
                            } else {
                              saveCroquiFazenda([geojson]);
                            }
                          });
                        };
                      }}
                    />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={modalCadTalhao}
        toggle={toggleCadTalhaoSafraCultura}
        size="lg"
      >
        <ModalHeader toggle={toggleCadTalhaoSafraCultura}>
          <Translator path="mapa.criarTalhao" />
        </ModalHeader>
        <Form ref={talhaoRef} onSubmit={(data) => handleSubmitCadtalhao(data)}>
          <ModalBody>
            <Row>
              <Col lg={6}>
                <Input
                  name="descricao"
                  label={<Translator path="fazenda.upload.descricao" />}
                  className="form-control"
                  type="text"
                />
              </Col>
              <Col lg={6}>
                <ReactSelectAsync
                  label={<Translator path="mapa.info.cultura" />}
                  name="id_cultura"
                  isClearable
                  loadOptions={optionsCulturas}
                />
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="success" type="submit">
              <Translator path="mapa.assist.adicionar.salvar" />
            </Button>
          </ModalFooter>
        </Form>
      </Modal>

      <Modal
        isOpen={modalVinculoSafraCroqui}
        toggle={toggleModalVinculoSafraCroqui}
        size="md"
      >
        {/* <ModalHeader>Selecione as culturas dos talhões importados</ModalHeader> */}
        <ModalHeader>
          <Translator path="fazenda.safratalhoescroqui.safras.verinfotalhoes.label" />
        </ModalHeader>
        <Form ref={talhaoRef} onSubmit={(data) => saveCroquiTalhao(data)}>
          <ModalBody>
            {talhoesVinculo &&
              talhoesVinculo?.map((e) => (
                <>
                  <Row key={e}>
                    <Col lg={6} className="text-center mt-4">
                      <h4>{e}</h4>
                    </Col>
                    <Col lg={6}>
                      <ReactSelectAsync
                        label="Cultura"
                        name={e}
                        isClearable
                        loadOptions={optionsCulturas}
                        defaultValue={{
                          label: 'Soja',
                          value: 4,
                        }}
                      />
                    </Col>
                  </Row>
                  <hr />
                </>
              ))}
          </ModalBody>
          <ModalFooter>
            <Button color="success" type="submit">
              <Translator path="mapa.assist.adicionar.salvar" />
            </Button>
          </ModalFooter>
        </Form>
      </Modal>

      <Modal isOpen={modalObs} toggle={toggleModalObs} size="xl">
        <ModalHeader toggle={toggleModalObs}>
          <Translator path="mapa.observacoes.label" />
        </ModalHeader>
        <ModalBody>
          <Table responsive>
            <thead>
              <tr>
                <th className="text-center">
                  <Translator path="mapa.observacoes.descricao" />
                </th>
                <th className="text-center">
                  <Translator path="mapa.observacoes.tipo" />
                </th>
                <th className="text-center">
                  <Translator path="mapa.observacoes.imagem" />
                </th>
                <th className="text-center">
                  <Translator path="mapa.observacoes.status" />
                </th>
                <th className="text-center">
                  <Translator path="mapa.observacoes.vernomapa" />
                </th>
              </tr>
            </thead>
            <tbody>
              {dataObs?.obs?.length > 0 ? (
                dataObs?.obs?.map((c) => (
                  <tr key={c?.id}>
                    <td className="text-center">{c?.descricao}</td>
                    <td className="text-center">{c?.tipo_observacao}</td>
                    <td className="text-center">
                      <Button
                        color="link p-0"
                        onClick={() => {
                          setModal(c);
                        }}
                      >
                        {c?.img_path && (
                          <img
                            src={c?.img_path}
                            alt="Img Obs."
                            className="img-preview cursor-pointer"
                          />
                        )}
                      </Button>
                    </td>
                    <td className="text-center">{c?.status}</td>
                    <td className="text-center">
                      {' '}
                      <Button
                        color="link p-0"
                        onClick={() => {
                          viewOnMap(c?.lat, c?.long, c);
                        }}
                      >
                        <FaMapMarker />
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td>
                    <Translator path="excecoes.semregistros" />
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
          <Pagination
            nextLabel={<FaChevronRight />}
            previousLabel={<FaChevronLeft />}
            pageCount={dataObs?.pages || 1}
            onPageChange={({ selected: sel }) =>
              getObs({ changePage: true, page: sel + 1 })
            }
            initialPage={0}
            containerClassName="pagination justify-end mr-1"
            activeClassName="active"
          />
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={toggleModalObs}>
            Ok
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={!!modal} toggle={toggleModal} size="lg">
        <ModalHeader toggle={toggleModal}>{modal?.descricao}</ModalHeader>
        <ModalBody>
          <img
            src={modal?.img_path}
            alt={modal?.descricao}
            className="img-modal"
          />
        </ModalBody>
      </Modal>

      <Modal isOpen={modalAti} toggle={toggleModalAti} size="xl">
        <ModalHeader toggle={toggleModalAti}>
          <Translator path="mapa.atividade.label" />
        </ModalHeader>
        <ModalBody>
          <div className="p-3 justify-content-between d-flex align-items-center">
            <Col lg={6}>
              <h6 className="txt-muted">
                <Translator path="mapa.atividade.totalregistros" />{' '}
                {atividades?.total}
              </h6>
            </Col>
            <Col />
            <div className="d-flex justify-content-center">
              <Button
                onClick={() => toggleModalAtiCad()}
                type="button"
                className="btn btn-primary ml-3"
              >
                <Translator path="mapa.novaAtividade" />
              </Button>
            </div>
            <div className="d-flex justify-content-center" />
          </div>
          <Table responsive>
            <thead>
              <tr>
                <th className="w-10 text-center">
                  <Translator path="mapa.atividade.insumos" />
                </th>
                <th className="w-10">
                  <Translator path="mapa.atividade.tipo" />
                </th>
                <th className="w-25">
                  <Translator path="mapa.atividade.observacoes" />
                </th>
                <th className="w-25">
                  <Translator path="mapa.atividade.parceiro" />
                </th>
                <th className="w-10">
                  <Translator path="mapa.atividade.status" />
                </th>
                <th className="w-10 text-center" colSpan={2}>
                  <Translator path="mapa.atividade.acoes" />
                </th>
              </tr>
            </thead>
            <tbody>
              {atividades?.atividades?.length > 0 ? (
                atividades?.atividades?.map((c) => (
                  <>
                    <tr key={c?.id}>
                      <td className="text-center">
                        <Button
                          className="outline"
                          onClick={() => {
                            const array = [...insumos];
                            const index = array.indexOf(c?.id);
                            if (index !== -1) {
                              array.splice(index, 1);
                              setInsumos(array);
                            } else {
                              array.push(c?.id);
                              setInsumos(array);
                            }
                          }}
                        >
                          {!insumos.includes(c?.id) ? (
                            <FaAngleDown />
                          ) : (
                            <FaAngleUp />
                          )}
                        </Button>
                      </td>
                      <td>{c?.tipo_atividade}</td>
                      <td>{c?.observacoes}</td>
                      <td>{c?.Parceiro?.nome}</td>
                      <td className="text-center">
                        <div>
                          {returnBadge(
                            new Date(c?.data_inicio),
                            new Date(c?.data_fim),
                            c?.status
                          )}
                        </div>
                      </td>
                      <td className="text-center" colSpan={2}>
                        <UncontrolledDropdown size="xs">
                          <DropdownToggle color="link link-gray" size="xs">
                            <FaEllipsisH size="1.3em" color="#43b02a" />
                          </DropdownToggle>
                          <DropdownMenu right>
                            <DropdownItem
                              onClick={() => getEditAtividade(c?.id)}
                              size="xs"
                            >
                              <FaEdit className="mr-1" size={18} />
                              <Translator path="mapa.atividade.action.label" />
                            </DropdownItem>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </td>
                    </tr>
                    {c?.AtividadeInsumos?.length > 0 ? (
                      c?.AtividadeInsumos.map((i) => (
                        <tr
                          key={i?.id + Math.random()}
                          hidden={!insumos.includes(c?.id)}
                          style={{
                            backgroundColor: '#ececec',
                            height: '50px',
                          }}
                        >
                          <td />
                          <td className="text-center">
                            <strong>
                              <Translator path="mapa.atividade.descricao" />:{' '}
                            </strong>
                            <br />
                            {i?.descricao_insumo}
                          </td>
                          <td className="text-center">
                            <strong>
                              <Translator path="mapa.atividade.tipo" />:{' '}
                            </strong>
                            <br />
                            {i?.insumo}
                          </td>
                          <td className="text-center">
                            <strong>
                              <Translator path="mapa.atividade.formulacaoTipo" />
                              :{' '}
                            </strong>
                            <br />
                            {i?.fertilizante_formulacao ||
                              i?.tipo_defensivo ||
                              ''}
                          </td>
                          <td className="text-center">
                            <strong>
                              <Translator path="mapa.atividade.quantidade" />:{' '}
                            </strong>
                            <br />
                            {i?.quantidade} - {i?.unidade_medida}
                          </td>
                          <td className="text-center" colSpan={2}>
                            <strong>
                              <Translator path="mapa.atividade.aplicacaoTotal" />
                              :{' '}
                            </strong>
                            <br />
                            {i?.quantidade_total} - {i?.unidade_medida}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr
                        key={Math.random()}
                        hidden={!insumos.includes(c?.id)}
                        style={{
                          backgroundColor: '#ececec',
                          height: '50px',
                        }}
                      >
                        <td />
                        <td colSpan={5}>
                          <Translator path="mapa.atividade.semInsumos" />
                        </td>
                      </tr>
                    )}
                  </>
                ))
              ) : (
                <tr>
                  <td>
                    <Translator path="excecoes.semregistros" />
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
          <Pagination
            nextLabel={<FaChevronRight />}
            previousLabel={<FaChevronLeft />}
            pageCount={atividades?.pages || 1}
            onPageChange={({ selected: sel }) =>
              getAtvidades({ changePage: true, page: sel + 1 })
            }
            initialPage={0}
            containerClassName="pagination justify-end mr-1"
            activeClassName="active"
          />
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={toggleModalAti}>
            Ok
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modalAtiCad} toggle={toggleModalAtiCad} size="lg">
        <ModalHeader toggle={toggleModalAtiCad}>
          {atividadeEdit ? (
            <Translator path="mapa.atividade.action.label" />
          ) : (
            <Translator path="mapa.atividade.action.labelCriar" />
          )}
        </ModalHeader>
        <Form
          ref={atividadeRef}
          onSubmit={(data) => handleSubmitAtividade(data, !!atividadeEdit)}
        >
          <ModalBody>
            <Row>
              <Col lg={6}>
                <Select
                  label={
                    <Translator path="mapa.atividade.action.tipodeatividade" />
                  }
                  className="form-control"
                  name="tipo_atividade"
                  defaultValue={atividadeEdit && atividadeEdit?.tipo_atividade}
                  data={[
                    {
                      label: Translator({
                        path: 'fazenda.upload.selecione',
                      }),
                      value: '',
                    },
                    {
                      label: Translator({
                        path: 'preparoSolo',
                      }),
                      value: Translator({
                        path: 'preparoSolo',
                      }),
                    },
                    {
                      label: Translator({
                        path: 'plantio',
                      }),
                      value: Translator({
                        path: 'plantio',
                      }),
                    },
                    {
                      label: Translator({
                        path: 'fertilizacao',
                      }),
                      value: Translator({
                        path: 'fertilizacao',
                      }),
                    },
                    {
                      label: Translator({
                        path: 'aplicacao',
                      }),
                      value: Translator({
                        path: 'aplicacao',
                      }),
                    },
                    {
                      label: Translator({
                        path: 'colheita',
                      }),
                      value: Translator({
                        path: 'colheita',
                      }),
                    },
                    {
                      label: Translator({
                        path: 'outra',
                      }),
                      value: Translator({
                        path: 'outra',
                      }),
                    },
                  ]}
                />
              </Col>
              <Col lg={6}>
                <Input
                  name="observacoes"
                  label={
                    <Translator path="mapa.atividade.action.novaatividade.observacoes" />
                  }
                  className="form-control"
                  defaultValue={atividadeEdit && atividadeEdit?.observacoes}
                  type="text"
                />
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <Input
                  name="data_inicio"
                  label={
                    <Translator path="mapa.atividade.action.novaatividade.datainicio" />
                  }
                  className="form-control"
                  defaultValue={
                    atividadeEdit && atividadeEdit?.data_inicio?.split('T')[0]
                  }
                  type="date"
                />
              </Col>
              <Col lg={6}>
                <Input
                  name="data_fim"
                  label={
                    <Translator path="mapa.atividade.action.novaatividade.datafim" />
                  }
                  className="form-control"
                  defaultValue={
                    atividadeEdit && atividadeEdit?.data_fim?.split('T')[0]
                  }
                  type="date"
                />
              </Col>
            </Row>
            <Row>
              <Col lg={12} className="justify-center">
                <Button type="button" onClick={() => toggleModalInsumo()}>
                  <Translator path="mapa.atividade.action.botaoadocionar" />
                </Button>
              </Col>
            </Row>
            <Row>
              <Card className="mt-3 mr-5 ml-5" style={{ borderRadius: 20 }}>
                <CardBody>
                  <Table responsive>
                    <thead>
                      <tr>
                        <th>
                          <Translator path="mapa.atividade.insumos" />
                        </th>
                        <th>
                          <Translator path="mapa.atividade.descricao" />
                        </th>
                        <th>
                          <Translator path="mapa.atividade.formulacaoTipo" />
                        </th>
                        <th>
                          <Translator path="mapa.atividade.quantidade" />
                        </th>
                        <th className="text-center">
                          <Translator path="mapa.atividade.acoes" />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {insumosCad?.length ? (
                        insumosCad?.map((e) => (
                          <tr key={e?.id}>
                            <td>{e?.insumo}</td>
                            <td>{e?.descricao_insumo}</td>
                            <td>
                              {e?.fertilizante_formulacao ||
                                e?.tipo_defensivo ||
                                ''}
                            </td>
                            <td>
                              {e?.quantidade} - {e?.unidade_medida}
                            </td>
                            <td className="text-center">
                              <Button
                                type="button"
                                color="danger"
                                onClick={() => {
                                  const array = [...insumosCad];

                                  const index = array
                                    .map((x) => x?.id)
                                    .indexOf(e?.id);

                                  array.splice(index, 1);
                                  setInsumosCad(array);
                                }}
                              >
                                <FaTrash />
                              </Button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td>
                            <Translator path="excecoes.semregistros" />
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="success" type="submit">
              <Translator path="mapa.assist.adicionar.salvar" />
            </Button>
          </ModalFooter>
        </Form>
      </Modal>

      <Modal isOpen={modalInsumo} toggle={toggleModalInsumo} size="lg">
        <ModalHeader toggle={toggleModalInsumo}>
          <Translator path="mapa.atividade.action.botaoadocionar" />
        </ModalHeader>
        <Form ref={insumoRef} onSubmit={(data) => handleSubmitInsumo(data)}>
          <ModalBody>
            <Row>
              <Col lg={6}>
                <Select
                  label={<Translator path="mapa.atividade.insumos" />}
                  className="form-control"
                  name="insumo"
                  onChange={(e) => setTipoInsumo(e?.target?.value)}
                  data={[
                    {
                      label: Translator({
                        path: 'fazenda.upload.selecione',
                      }),
                      value: '',
                    },
                    {
                      label: Translator({
                        path: 'Fertilizante',
                      }),
                      value: Translator({
                        path: 'Fertilizante',
                      }),
                    },
                    {
                      label: Translator({
                        path: 'Defensivo',
                      }),
                      value: Translator({
                        path: 'Defensivo',
                      }),
                    },
                    {
                      label: Translator({
                        path: 'Cultura',
                      }),
                      value: Translator({
                        path: 'Cultura',
                      }),
                    },
                  ]}
                />
              </Col>
              <Col lg={6}>
                <Input
                  name="descricao_insumo"
                  label={<Translator path="mapa.atividade.descricao" />}
                  className="form-control"
                  type="text"
                />
              </Col>
            </Row>
            <Row>
              {tipoInsumo === 'Defensivo' && (
                <Col lg={12}>
                  <Input
                    name="tipo_defensivo"
                    label={<Translator path="mapa.atividade.formulacaoTipo" />}
                    className="form-control"
                    type="text"
                  />
                </Col>
              )}
              {tipoInsumo === 'Fertilizante' && (
                <Col lg={12}>
                  <Input
                    name="fertilizante_formulacao"
                    label={<Translator path="mapa.atividade.formulacaoTipo" />}
                    className="form-control"
                    type="text"
                  />
                </Col>
              )}
            </Row>
            <Row>
              <Col lg={6}>
                <Input
                  name="quantidade"
                  label={<Translator path="mapa.atividade.quantidade" />}
                  className="form-control"
                  type="number"
                  step="0.01"
                />
              </Col>
              <Col lg={6}>
                <Select
                  label={<Translator path="mapa.unidadeMedida" />}
                  className="form-control"
                  name="unidade_medida"
                  data={[
                    {
                      label: Translator({
                        path: 'fazenda.upload.selecione',
                      }),
                      value: '',
                    },
                    {
                      label: Translator({
                        path: 'mapa.unidadeMedida.kg',
                      }),
                      value: 'Kg',
                    },
                    {
                      label: Translator({
                        path: 'mapa.unidadeMedida.g',
                      }),
                      value: 'g',
                    },
                    {
                      label: Translator({
                        path: 'mapa.unidadeMedida.mg',
                      }),
                      value: 'Mg',
                    },
                    {
                      label: Translator({
                        path: 'mapa.unidadeMedida.t',
                      }),
                      value: 't',
                    },
                    {
                      label: Translator({
                        path: 'mapa.unidadeMedida.l',
                      }),
                      value: 'L',
                    },
                    {
                      label: Translator({
                        path: 'mapa.unidadeMedida.ml',
                      }),
                      value: 'ml',
                    },
                    {
                      label: Translator({
                        path: 'mapa.unidadeMedida.m3',
                      }),
                      value: 'm³',
                    },
                  ]}
                />
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="success" type="submit">
              <Translator path="mapa.atividade.action.novaatividade.botao adicionar" />
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
      <Modal isOpen={!!docs} toggle={() => setDocs(null)} size="lg">
        <ModalHeader toggle={() => setDocs(null)}>
          Assist {tipoAssist}
        </ModalHeader>
        <ModalBody>
          <Table responsive>
            <thead>
              <tr>
                <th className="text-center">
                  <Translator path="mapa.assist.nomearquivo" />
                </th>
                <th className="text-center">
                  <Translator path="mapa.assist.visualizarpdf" />
                </th>
                <th className="text-center">...</th>
              </tr>
            </thead>
            <tbody>
              {docs?.obs?.length ? (
                docs?.obs?.map((c) => (
                  <tr key={c?.id}>
                    <td className="text-center">{c?.nome_arquivo}</td>
                    <td className="text-center">
                      <Button
                        color="link p-0"
                        onClick={() => {
                          window.open(c.path);
                        }}
                      >
                        <FaLink />
                      </Button>
                    </td>
                    <td className="text-center">
                      <Button
                        color="danger p-0"
                        onClick={() => {
                          handleDelete(c?.id);
                        }}
                        hidden={user?.perfil === 2 || user?.perfil === 4}
                      >
                        <FaRegTrashAlt />
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td>
                    <Translator path="excecoes.semregistros" />
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </ModalBody>
        <ModalFooter className="justify-content-between">
          <Button
            color="primary"
            onClick={() => setDocs((old) => ({ ...old, novo: true }))}
          >
            <Translator path="mapa.assist.botaoadd" />
          </Button>
          <Pagination
            nextLabel={<FaChevronRight />}
            previousLabel={<FaChevronLeft />}
            pageCount={docs?.pages || 1}
            onPageChange={({ selected: sel }) => getDocs({ page: sel + 1 })}
            initialPage={0}
            containerClassName="pagination"
            activeClassName="active"
          />
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={docs?.novo}
        toggle={() => setDocs((old) => ({ ...old, novo: false }))}
        size="lg"
      >
        <ModalHeader toggle={() => setDocs((old) => ({ ...old, novo: false }))}>
          <Translator path="mapa.assist.botaoadd" />
        </ModalHeader>
        <ModalBody>
          <Form ref={formDocsRef} onSubmit={(e) => handleSubmitDocs(e)}>
            <Row>
              <Col>
                <Input
                  name="nome_arquivo"
                  className="form-control"
                  label={
                    <Translator path="mapa.assist.adicionar.nomearquivo" />
                  }
                />
              </Col>
              <Col>
                <Input
                  name="file"
                  type="file"
                  accept="application/pdf"
                  label={<Translator path="mapa.assist.adicionar.arquivo" />}
                />
              </Col>
            </Row>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={() => formDocsRef.current.submitForm()}
          >
            <Translator path="mapa.assist.adicionar.salvar" />
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={dispositivosPlugField?.show}
        toggle={() =>
          setDispositivosPlugField((old) => ({ ...old, show: false }))
        }
        size="lg"
      >
        <ModalHeader
          toggle={() =>
            setDispositivosPlugField((old) => ({ ...old, show: false }))
          }
        >
          <Translator path="mapa.plugfield.label" />
        </ModalHeader>
        <ModalBody>
          <Table responsive>
            <thead>
              <tr>
                <th className="text-center">
                  <Translator path="mapa.plugfield.nome" />
                </th>
                <th className="text-center">
                  <Translator path="mapa.plugfield.Id" />
                </th>
                <th className="text-center">
                  <Translator path="mapa.plugfield.acao" />
                </th>
              </tr>
            </thead>
            <tbody>
              {dispositivosPlugField?.dispositivos?.length ? (
                dispositivosPlugField?.dispositivos?.map((c) => (
                  <tr key={c?.id}>
                    <td className="text-center">{c?.nome}</td>
                    <td className="text-center">{c?.serial}</td>
                    <td className="text-center">
                      <Button
                        color="primary"
                        onClick={() => verInfosPuglfield(c?.serial, 'P')}
                      >
                        <Translator path="mapa.plugfield.previsao" />
                      </Button>
                      <Button
                        color="primary"
                        onClick={() => verInfosPuglfield(c?.serial, 'H')}
                      >
                        <Translator path="mapa.plugfield.historico" />
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td>
                    <Translator path="excecoes.semregistros" />
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={infosPlugField?.show}
        toggle={() => setInfosPlugField((old) => ({ ...old, show: false }))}
        size="xl"
      >
        <ModalHeader
          toggle={() => setInfosPlugField((old) => ({ ...old, show: false }))}
        >
          <Translator path="mapa.plugfield.historico.label" />
        </ModalHeader>
        <ModalBody>
          {infosPlugField?.tipo === 'P' ? (
            <Table responsive striped>
              <thead>
                <tr>
                  <th className="text-center">
                    <Translator path="mapa.plugfield.previsao.grid.dia" />
                  </th>
                  <th className="text-center">
                    <Translator path="mapa.plugfield.previsao.grid.tipo" />
                  </th>
                  <th>
                    <Translator path="mapa.plugfield.previsao.grid.temperatura" />
                  </th>
                  <th>
                    <Translator path="mapa.plugfield.previsao.grid.minimo" />
                  </th>
                  <th>
                    <Translator path="mapa.plugfield.previsao.grid.maximo" />
                  </th>
                  <th>
                    <Translator path="mapa.plugfield.previsao.grid.umidade" />
                  </th>
                  <th>
                    <Translator path="mapa.plugfield.previsao.grid.chuva" />
                  </th>
                </tr>
              </thead>
              <tbody>
                {infosPlugField?.infos?.length ? (
                  infosPlugField?.infos?.map((c) => (
                    <tr key={c?.id}>
                      <td className="text-center">{c?.data}</td>
                      <td className="text-center">
                        {capitalizeFirstLetter(c?.tipo)}
                      </td>
                      <td>
                        <Row>
                          <Col lg={2}>
                            <TbTemperature />
                          </Col>
                          <Col lg={10}>{c?.temperatura} Cº</Col>
                        </Row>
                      </td>
                      <td>
                        <Row>
                          <Col lg={2}>
                            <TbTemperatureMinus />
                          </Col>
                          <Col lg={10}>{c?.min} Cº</Col>
                        </Row>
                      </td>
                      <td>
                        <Row>
                          <Col lg={2}>
                            <TbTemperaturePlus />
                          </Col>
                          <Col lg={10}>{c?.max} Cº</Col>
                        </Row>
                      </td>
                      <td>
                        <Row>
                          <Col lg={2}>
                            <WiHumidity />
                          </Col>
                          <Col lg={10}>{c?.umidade} %</Col>
                        </Row>
                      </td>
                      <td>
                        <Row>
                          <Col lg={2}>
                            <FaCloudRain />
                          </Col>
                          <Col lg={10}>{c?.chuva} mm</Col>
                        </Row>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td>
                      <Translator path="excecoes.semregistros" />
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          ) : (
            <>
              {infosPlugField?.infos?.length ? (
                <>
                  <Row className="mb-5 mt-2">
                    <Col>
                      <Row className="text-center">
                        <Col>
                          <h1>
                            <TbTemperature style={{ marginRight: 15 }} />
                            {infosPlugField?.infos[0]?.temperatura} Cº
                          </h1>
                        </Col>
                      </Row>
                      <hr />
                      <Row className="justify-center">
                        <Col lg={4}>
                          <h4>
                            <TbTemperatureMinus style={{ marginRight: 15 }} />
                            {infosPlugField?.infos[0]?.min} Cº min
                          </h4>
                        </Col>
                        <Col lg={4}>
                          <h4>
                            <TbTemperaturePlus style={{ marginRight: 15 }} />
                            {infosPlugField?.infos[0]?.max} Cº max
                          </h4>
                        </Col>
                      </Row>
                    </Col>
                    <Col>
                      <Row className="text-center">
                        <Col>
                          {getDirection(infosPlugField?.infos[0]?.vento_dir)}
                        </Col>
                      </Row>
                      <hr />
                      <Row className="justify-center">
                        <Col lg={5}>
                          <h4>
                            <Translator path="mapa.plugfield.historico.vento" />{' '}
                            <WiWindy style={{ marginRight: 15 }} />
                            {infosPlugField?.infos[0]?.vento} Km/h
                          </h4>
                        </Col>
                        <Col lg={5}>
                          <h4>
                            <Translator path="mapa.plugfield.historico.rajada" />{' '}
                            <WiStrongWind style={{ marginRight: 15 }} />
                            {infosPlugField?.infos[0]?.rajada} Km/h
                          </h4>
                        </Col>
                      </Row>
                    </Col>
                  </Row>

                  <hr />
                  <Row className="text-center mt-5">
                    <Col>
                      <h4>
                        <Translator path="mapa.plugfield.historico.sensacao" />:{' '}
                        {infosPlugField?.infos[0]?.sensacao} Cº
                        <TbTemperature style={{ marginLeft: 15 }} />
                      </h4>
                    </Col>
                    <Col>
                      <h4>
                        <Translator path="mapa.plugfield.historico.chuva" />:{' '}
                        {infosPlugField?.infos[0]?.chuva_agora} mm
                        <FaCloudRain style={{ marginLeft: 15 }} />
                      </h4>
                    </Col>
                    <Col>
                      <h4>
                        <Translator path="mapa.plugfield.historico.precipitacaodia" />
                        : {infosPlugField?.infos[0]?.chuva_dia} mm
                        <FaCloudRain style={{ marginLeft: 15 }} />
                      </h4>
                    </Col>
                  </Row>
                  <Row className="text-center mb-5">
                    <Col>
                      <h4>
                        <Translator path="mapa.plugfield.historico.umidade" />:{' '}
                        {infosPlugField?.infos[0]?.umidade} %
                        <WiHumidity style={{ marginLeft: 15 }} />
                      </h4>
                    </Col>
                    <Col>
                      <h4>
                        Evapotransp.: {infosPlugField?.infos[0]?.evapotransp} mm
                        <MdWaterDrop style={{ marginLeft: 15 }} />
                      </h4>
                    </Col>
                    <Col>
                      <h4>
                        <Translator path="mapa.plugfield.historico.pressao" />:{' '}
                        {infosPlugField?.infos[0]?.pressao} hPa
                        <BsSpeedometer style={{ marginLeft: 15 }} />
                      </h4>
                    </Col>
                  </Row>
                  <hr />
                  <Row className="text-center">
                    <Col>
                      <h4>
                        UV máx: {infosPlugField?.infos[0]?.uv}
                        <BsThermometerSun style={{ marginLeft: 15 }} />
                      </h4>
                    </Col>
                    <Col>
                      <h4>
                        <Translator path="mapa.plugfield.historico.luminosidade" />
                        : {infosPlugField?.infos[0]?.luminosidade} lux
                        <BsSunrise style={{ marginLeft: 15 }} />
                      </h4>
                    </Col>
                  </Row>
                  <hr />
                  <Row className="text-center">
                    <Col>
                      <h4>
                        Delta T: {deltaT(infosPlugField?.infos[0]?.delta_t)}
                      </h4>
                    </Col>
                    <Col>
                      <h4>
                        Delta T min: {infosPlugField?.infos[0]?.delta_t_min}
                      </h4>
                    </Col>
                    <Col>
                      <h4>
                        Delta T max: {infosPlugField?.infos[0]?.delta_t_max}
                      </h4>
                    </Col>
                  </Row>
                  <hr />
                  <Row className="justify-end mt-3">
                    <Col lg={3}>
                      <p>
                        <Translator path="mapa.atualizado" />{' '}
                        {infosPlugField?.infos[0]?.atualizacao}
                      </p>
                    </Col>
                  </Row>
                </>
              ) : (
                <p>
                  <Translator path="excecoes.semregistros" />
                </p>
              )}
            </>
          )}
        </ModalBody>
      </Modal>

      <ModalLog data={dadosModalLog} setData={(e) => setDadosModalLog(e)} />
    </>
  );
}
export default Map;
